/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type AdVehicleStreamHubReturnVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  isResponsive: boolean | null
  fleet: { __typename?: 'Fleet'; id: string } | null
  region: { __typename?: 'Region'; id: string } | null
  latestADTelemetry: {
    __typename?: 'ADTelemetry'
    sdsMode: {
      __typename?: 'SDSModeWithTimestamp'
      sdsMode: Types.SdsMode
    } | null
  } | null
  pooling: { __typename?: 'Pooling'; enabled: boolean } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          id: string
          trip: { __typename?: 'Trip'; id: string } | null
        }
      | {
          __typename: 'FccWaypointHubReturnAction'
          id: string
          reason: Types.FccWaypointHubReturnReason
          estimatedAt: string
        }
      | {
          __typename: 'FccWaypointPickupAction'
          id: string
          trip: { __typename?: 'Trip'; id: string } | null
        }
      | { __typename: 'FccWaypointReallocationAction' }
    >
  }> | null
}

export const AdVehicleStreamHubReturnVehicleFragmentDoc = gql`
    fragment AdVehicleStreamHubReturnVehicle on Vehicle {
  id
  fleet {
    id
  }
  region {
    id
  }
  latestADTelemetry {
    sdsMode {
      sdsMode
    }
  }
  isResponsive
  pooling {
    enabled
  }
  fccUpcomingWaypoints {
    actions {
      __typename
      ... on FccWaypointPickupAction {
        id
        trip {
          id
        }
      }
      ... on FccWaypointDeliveryAction {
        id
        trip {
          id
        }
      }
      ... on FccWaypointHubReturnAction {
        id
        reason
        estimatedAt
      }
    }
  }
}
    `
